const theme = {
  blockCursor: 'sn-block-cursor',
  paragraph: 'sn-paragraph',
  heading: {
    h1: 'sn-heading',
    h2: 'sn-heading',
    h3: 'sn-heading',
    h4: 'sn-heading',
    h5: 'sn-heading',
    h6: 'sn-heading'
  },
  quote: 'sn-quote',
  image: 'sn-image',
  media: 'sn-media',
  mediaImg: 'sn-media__img',
  mediaVideo: 'sn-media__video',
  link: 'sn-link',
  code: 'sn-code-block',
  userMention: 'sn-link',
  territoryMention: 'sn-link',
  itemMention: 'sn-link',
  embeds: {
    placeholder: 'sn-embed-placeholder',
    base: 'sn-embed-wrapper',
    twitter: {
      container: 'sn-twitter-container',
      contained: 'sn-embed-contained',
      embed: 'sn-embed--twitter'
    },
    nostr: {
      container: 'sn-nostr-container',
      contained: 'sn-embed-contained',
      embed: 'sn-embed--nostr'
    },
    wavlake: {
      container: 'sn-wavlake-wrapper',
      embed: 'sn-embed--wavlake'
    },
    spotify: {
      container: 'sn-spotify-wrapper',
      embed: 'sn-embed--spotify'
    },
    youtube: {
      container: 'sn-video-wrapper',
      embed: 'sn-embed--youtube'
    },
    rumble: {
      container: 'sn-video-wrapper',
      embed: 'sn-embed--rumble'
    },
    peertube: {
      container: 'sn-video-wrapper',
      embed: 'sn-embed--peertube'
    }
  },
  list: {
    nested: {
      listitem: 'sn-list__nested-item'
    },
    olDepth: [
      'sn-list-ol1',
      'sn-list-ol2',
      'sn-list-ol3',
      'sn-list-ol4',
      'sn-list-ol5'
    ],
    ul: 'sn-list-ul',
    listitem: 'sn-list__item',
    listitemChecked: 'sn-list__item--checked',
    listitemUnchecked: 'sn-list__item--unchecked'
  },
  table: 'sn-table',
  tableCell: 'sn-table__cell',
  tableCellActionButton: 'sn-table__action-button',
  tableCellActionButtonContainer:
    'sn-table__action-button-container',
  tableCellHeader: 'sn-table__cell--header',
  tableCellResizer: 'sn-table__cell-resizer',
  tableCellSelected: 'sn-table__cell--selected',
  tableScrollableWrapper: 'sn-table__scrollable-wrapper',
  tableSelected: 'sn-table--selected',
  tableSelection: 'sn-table--selection',
  tableAlignment: {
    center: 'sn-table--align-center',
    right: 'sn-table--align-right'
  },
  text: {
    bold: 'sn-text__bold',
    italic: 'sn-text__italic',
    highlight: 'sn-text__highlight',
    underline: 'sn-text__underline',
    strikethrough: 'sn-text__strikethrough',
    underlineStrikethrough: 'sn-text__underline-strikethrough',
    superscript: 'sn-text__superscript',
    subscript: 'sn-text__subscript'
  },
  math: 'sn-math',
  hr: 'sn-hr',
  toc: 'sn-toc',
  footnoteReference: 'sn-footnote-ref',
  footnoteDefinition: 'sn-footnote-def',
  footnotesSection: 'sn-footnotes',
  footnoteBackref: 'sn-footnote-backref'
}

export default theme
